import { useCallback } from 'react';

import type { TripImportEntry } from '@/models/itineraryImportTypes';
import { useTripImport, type OpenTripImportOptions } from '@/contexts/TripImportContext';

interface OpenTripImportRouteOptions {
  text?: string;
  entry?: TripImportEntry;
  onCompleteSave?: OpenTripImportOptions['onCompleteSave'];
}

export function useOpenTripImportRoute() {
  const { openTripImport } = useTripImport();

  return useCallback(
    (options: OpenTripImportRouteOptions = {}) => {
      openTripImport({
        prefilledText: options.text,
        entry: options.entry,
        onCompleteSave: options.onCompleteSave,
      });
    },
    [openTripImport],
  );
}
